
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, paymentsModule } from '@/store/modules/store-accessor'
import { formatAmount } from '@/helpers/data'

@Component
export default class DeletePaymentModal extends Vue {
  @Prop()
  payload!: any;

  isDeletingPayment = false;
  depositLookupDone = false;
  creditDepositAmount = 0;
  creditClientName = '';

  get paymentAmount() {
    return formatAmount(Number(this.payload.payment.amount) || 0);
  }

  get deletedPaymentLine() {
    return `${this.$t('deletePaymentAmountUnit', { amount: this.paymentAmount })} ${this.$t('deletePaymentBulletPayment')}`;
  }

  get paymentReturnedMessage() {
    if (this.creditClientName) {
      return this.$t('deletePaymentReturnedToCredit', { amount: this.paymentAmount, client: this.creditClientName });
    }
    return this.$t('deletePaymentReturnedToCreditFallback', { amount: this.paymentAmount });
  }

  get depositStaysMessage() {
    const amount = formatAmount(this.creditDepositAmount);
    if (this.creditClientName) {
      return this.$t('deletePaymentDepositStays', { amount, client: this.creditClientName });
    }
    return this.$t('deletePaymentDepositStaysFallback', { amount });
  }

  async hideModal () {
    commonModule.hideModal();
  }

  async mounted() {
    commonModule.initSnackbar({});
    try {
      const deposit = await paymentsModule.getPaymentCreditDeposit(this.payload.payment.id);
      this.creditDepositAmount = Number(deposit && deposit.amount) || 0;
      const fromDeposit = deposit && deposit.client_name;
      const payment = this.payload.payment || {};
      const clientName = String(fromDeposit || payment.client_full_name || payment.client_name || '').trim();
      this.creditClientName = clientName === '-' ? '' : clientName;
    } finally {
      this.depositLookupDone = true;
    }
  }

  doDeletePayment () {
        this.isDeletingPayment = true;
        paymentsModule.deletePayment(this.payload.payment);
        this.hideModal();
  }
};
